import { getInitialPageFromDOM, router, setupProgress, } from '@inertiajs/core';
import { escape } from 'lodash-es';
import App, {} from './components/App.svelte';
import { config } from './index';
export default async function createInertiaApp({ id = 'app', resolve, setup, progress = {}, page, defaults = {}, }) {
    config.replace(defaults);
    const isServer = typeof window === 'undefined';
    const useScriptElementForInitialPage = config.get('future.useScriptElementForInitialPage');
    const initialPage = page || getInitialPageFromDOM(id, useScriptElementForInitialPage);
    const resolveComponent = (name) => Promise.resolve(resolve(name));
    const svelteApp = await Promise.all([
        resolveComponent(initialPage.component),
        router.decryptHistory().catch(() => { }),
    ]).then(([initialComponent]) => {
        return setup({
            el: isServer ? null : document.getElementById(id),
            App,
            props: { initialPage, initialComponent, resolveComponent },
        });
    });
    if (isServer && svelteApp) {
        const { html, head, css } = svelteApp;
        return {
            body: useScriptElementForInitialPage
                ? `<script data-page="${id}" type="application/json">${JSON.stringify(initialPage).replace(/\//g, '\\/')}</script><div data-server-rendered="true" id="${id}">${html}</div>`
                : `<div data-server-rendered="true" id="${id}" data-page="${escape(JSON.stringify(initialPage))}">${html}</div>`,
            head: [head, css ? `<style data-vite-css>${css.code}</style>` : ''],
        };
    }
    if (!isServer && progress) {
        setupProgress(progress);
    }
}
